import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../../utils/data-load-error/data-load-error";

export enum DriverPlanEntryCheckoutEventAddErrorType {
  DRIVER_HAS_CANDIDATURE = "DRIVER_HAS_CANDIDATURE",
}

export enum DriverPlanEntryCheckoutEventAddDefaultErrorType {
  DEFAULT = "DEFAULT",
}

export type DriverPlanEntryCheckoutEventDefaultError = DataLoadError<
  DriverPlanEntryCheckoutEventAddDefaultErrorType.DEFAULT,
  {}
>;

export type DriverPlanEntryCheckoutEventDriverHasCandidatureError =
  DataLoadError<
    DriverPlanEntryCheckoutEventAddErrorType.DRIVER_HAS_CANDIDATURE,
    {}
  >;

type DriverPlanEntryCheckoutEventAddError =
  | DataLoadDefaultErrors
  | DriverPlanEntryCheckoutEventDriverHasCandidatureError
  | DriverPlanEntryCheckoutEventDefaultError;

export default DriverPlanEntryCheckoutEventAddError;
